/**
 * Created by mongoose on 8/11/17.
 */
import { BASE_URL } from "../../request";
import ModuleTranslations from "./ModuleTranslations";
import { getTranslatedDefinition } from "../utils";

const ModuleDefinition = {
  name: "Info Legal",
  entityName: "legalInfo",
  restConfig: {
    baseURL: `${BASE_URL}`,
    create: {
      url: () => `/api/legal/legalInfo/`,
      method: "post",
      resetCache: true,
    },
    update: {
      url: ({ id }) => `/api/legal/legalInfo/`,
      method: "put",
      resetCache: true,
    },
    fetch: {
      url: ({ hotelTicker, id }) => `/api/legal/${hotelTicker}/legalInfo/${id ? id : ""}`,
      method: "get",
    },
    delete: {
      url: ({ hotelTicker, id }) => `/api/legal/${hotelTicker}/legalInfo/${id}`,
      method: "delete",
      resetCache: true,
    },
  },
  renderers: {
    list: {},
    form: {},
  }, //render functions by attribute name, this overrides default widgets specified in the fields section
  translation: {
    translated: true,
    fieldName: "translations",
    displayName: "Traducciones",
    widget: "translations",
    entityProperty: "translations",
  },
  fields: {
    list: [
      //columns to be used in the table/list display, Order IS important
      {
        fieldName: "hotelTicker",
        displayName: "Ticker de hotel",
      },
      {
        fieldName: "property",
        displayName: "Tipo de Política",
      },
    ],
    form: [
      //fields to be used in the creation/edit form display, Order IS important
      {
        fieldName: "id",
        widget: "hidden",
      },
      {
        fieldName: "hotelTicker",
        displayName: "hotel Ticker",
        widget: "hidden",
      },
      {
        fieldName: "property",
        displayName: "Tipo de Política",
        widget: "selector",
        optionDisplay: {
          PRIVACY_POLICY: {
            label: "Política de Privacidad",
          },
          COMMUNICATIONS_POLICY: {
            label: "Política de Comunicación",
          },
        },
        helpText:
          "Política de Privacidad: Texto para explicar conformidad con LOPD and GDPR</br>" +
          "Política de Comunicación: Texto que el usuario leerá para aceptar la recepción de ofertas e información promocional",
        defaultValue: "PRIVACY_POLICY",
      },
      {
        fieldName: "text",
        displayName: "Texto",
        widget: "textarea",
        translated: true,
      },
    ],
  },
  validation: {
    id: {
      type: "String",
      constraints: {
        presence: {
          allowEmpty: true,
        },
      },
    },
    hotelTicker: {
      type: "String",
      constraints: {
        presence: {
          allowEmpty: false,
        },
      },
    },
    property: {
      type: "Enum",
      constraints: {
        inclusion: {
          within: ["PRIVACY_POLICY", "COMMUNICATIONS_POLICY"],
        },
        presence: {
          allowEmpty: false,
        },
      },
      defaultValue: "PRIVACY_POLICY",
    },
    text: {
      type: "String",
      constraints: {
        presence: {
          allowEmpty: false,
        },
      },
    },
  },
};

export default ({ locale }) =>
  getTranslatedDefinition({ ModuleDefinition, ModuleTranslations, locale });
